import { Nullable } from '../utility-types';
import { FINcredbileReport, GenericReport } from './report';
import { CheckLanguage } from '../check';
import { Feature } from './flags';
import { Country } from '../../constants/country-phone-number';

export const BANK_INTEGRATION_VENDORS = ['FINCREDIBLE', 'KLARNA'] as const;

export type BankIntegrationVendor = typeof BANK_INTEGRATION_VENDORS[number];

export type Check = {
	checkId: string;
	persona: Persona;
	language: CheckLanguage;
	bankAccount?: BankAccount;
	reports: Array<GenericReport | FINcredbileReport>;
	flags: Array<Feature>;
	additionalConsents?: string;
	metadata: Metadata;
	vendor: BankIntegrationVendor;
	integrations?: CheckIntegration[];
};

export enum CheckIntegrationStatus {
	PENDING = 'PENDING',
	PROCESSING = 'PROCESSING',
	SUCCESS = 'SUCCESS',
	ACCEPTED = 'ACCEPTED',
	ERROR = 'ERROR',
	CANCELLED = 'CANCELLED'
}

export enum CheckFlagName {
	ID_AUSTRIA = 'ID_AUSTRIA',
	PHOTO_IDENT = 'POS_PHOTO_IDENT'
}

export type CheckIntegration = {
	name: string;
	status: CheckIntegrationStatus;
	result: Record<string, unknown>;
};

export enum IdentitySourceName {
	ID_AUSTRIA = 'ID_AUSTRIA',
	POS_PHOTO_IDENT = 'POS_PHOTO_IDENT'
}

export type PosPhotoIdentMetadata = {
	redirectUrl?: string;
	IdentificationUrl?: string;
	isRedirected?: boolean;
	sessionRedirected?: boolean;
};

export type IdentitySource = {
	source: IdentitySourceName | string;
	status: CheckIntegrationStatus | string;
	firstName?: string;
	lastName?: string;
	dateOfBirth?: string;
	metadata?: PosPhotoIdentMetadata;
};

export type Persona = {
	firstName: string;
	lastName: string;
	middleName: Nullable<string>;
	dateOfBirth: Nullable<string>;
	residence: Residence;
	contacts: Contact;
	identity?: IdentitySource[];
};

export type Residence = Nullable<{
	country: Country;
	street: string;
	houseNumber: string;
	topNumber: string;
	city: string;
	postalCode: string;
}>;

export type Contact = Nullable<{
	email: string;
	phoneNumber: string;
}>;

export type BankAccount = {
	accountHolder: string;
	iban: string;
	bic: string;
	bankName: string;
	bankCountry: string;
};

export type Metadata = {
	check: MetadataCheck;
	account: MetadataAccount;
	assets: Array<Asset>;
	parties?: Array<Party>;
};

export type MetadataAccount = {
	companyName: Nullable<string>;
	firstName: string;
	lastName: string;
};

export type MetadataCheck = {
	language?: string;
	codes?: { code: string }[];
	finishCheck?: boolean;
};

export type AssetType = 'logo' | 'title' | 'color';

export type Asset = {
	type: AssetType;
	value: string;
};

export type Party = {
	type?: string;
	id?: string;
	firstName: string;
	lastName: string;
	companyName: string;
	companyRegNumber?: string;
	street?: string;
	streetNumber?: string;
	streetTop?: string;
	city?: string;
	country?: string;
	postalCode?: string;
	uid?: string;
	contactEmail?: string;
	billingEmail?: string;
};
